/**
 * PipelineWidget — Pipeline (R$ em aberto) do Comercial.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterPainel } from "../../../services/comercialPainel";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "pipeline",
  label: "Pipeline comercial",
  descricao: "O mesmo número do Pipeline aberto do Painel Comercial.",
  categoria: "Comercial",
  permissoes: ["comercial:metricas"],
  tamanho_default: "M",
  essencial: true,
};

export async function fetchData(request) {
  return await obterPainel(request);
}

function fmt(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

// Lia `dados.pipeline` (um objeto {soma, qtd}) como número e chaves que o
// payload nunca teve — mostrava "—" sempre. Agora le o mesmo campo do card
// "Pipeline aberto" do painel, e a contagem diz se sao leads ou orcamentos
// (segue a fonte configurada da unidade).
export function Widget({ dados }) {
  const v = dados?.pipeline?.soma ?? null;
  const qtd = dados?.pipeline?.qtd ?? null;
  const porOrcamento = dados?.fontes?.pipeline === "orcamento";
  return (
    <>
      <CardBody>
        <KpiValor>{fmt(v)}</KpiValor>
        <KpiSub>
          {qtd != null
            ? `${qtd} ${porOrcamento ? "orçamento" : "lead"}${Number(qtd) === 1 ? "" : "s"} em aberto`
            : "valor em negociação"}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/comercial/painel">Ver painel comercial</LinkLight>
      </CardFooter>
    </>
  );
}
